export default "__VITE_ASSET__yfpHLMvVGeugh68pjJSSiA__"